import { FC, useState } from 'react'
import toast from 'react-hot-toast'
import useOrder, { TTrackingState } from '../../hooks/useOrder'
import { IOrder } from '../../model/IOrder'
import { msg } from '../../msg'
import TrackingWidget from './TrackingWidget'

const TrackingProductsWidget: FC<{ order: IOrder }> = ({ order }) => {
  const [errState, setErrState] = useState<Partial<Record<keyof TTrackingState, string>>>()
  const { patchAllProductsTrackings, loading } = useOrder()
  const [isModal, setIsModal] = useState<boolean>(false)

  const addTracking = async (state: TTrackingState) => {
    setErrState(() => undefined)
    const errs = await patchAllProductsTrackings(state, order)
    if (errs) setErrState(() => errs)
    else {
      toast.success(msg('success-tracking-products-adding'), { duration: 5000 })
      setIsModal(() => false)
    }
  }

  return (
    <TrackingWidget
      // state={}
      errors={errState}
      loading={loading}
      title='Edit Tracking Information for All Products'
      buttonTitle='Edit Tracking Information for ALL products'
      onClick={addTracking}
      isShown={isModal}
      setIsShown={setIsModal}
    />
  )
}

export default TrackingProductsWidget
